import { b64ToBytes } from "../b64.js";

/**
 * Short, comparable form of a public key: the first 10 bytes of its SHA-256 in hex, in groups of
 * four ("3F2A 9C01 …"). Admins and users compare it out of band to spot a swapped key.
 */
export async function keyFingerprint(publicKeyB64: string): Promise<string> {
  const digest = new Uint8Array(await crypto.subtle.digest("SHA-256", new Uint8Array(b64ToBytes(publicKeyB64))));
  const hex = Array.from(digest.slice(0, 10), (b: number): string => b.toString(16).padStart(2, "0")).join("").toUpperCase();
  return hex.match(/.{4}/g)?.join(" ") ?? hex;
}
